const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://landingpagecreatorbackend.azurewebsites.net/api';

export const audiencesAPI = {
  // Get all audiences for a website
  getAll: async (websiteId) => {
    const response = await fetch(`${API_BASE_URL}/websites/${websiteId}/audiences`);
    if (!response.ok) {
      throw new Error('Failed to fetch audiences');
    }
    return response.json();
  },

  // Get a specific audience for a website
  getById: async (websiteId, audienceId) => {
    const response = await fetch(`${API_BASE_URL}/websites/${websiteId}/audiences/${audienceId}`);
    if (!response.ok) {
      throw new Error('Failed to fetch audience');
    }
    return response.json();
  },

  // Create a new audience for a website
  create: async (websiteId, name, description = '', importFromAudienceId = null, storageTargetId = undefined) => {
    const response = await fetch(`${API_BASE_URL}/websites/${websiteId}/audiences`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        description,
        importFromAudienceId,
        ...(storageTargetId !== undefined ? { storageTargetId } : {}),
      }),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to create audience');
    }
    return response.json();
  },

  // Update an audience (only include fields to change)
  update: async (
    websiteId,
    audienceId,
    { name, description, storageTargetId, importHtmlFromAudienceId } = {}
  ) => {
    const body = {};
    if (name !== undefined) body.name = name;
    if (description !== undefined) body.description = description;
    if (storageTargetId !== undefined) body.storageTargetId = storageTargetId;
    if (importHtmlFromAudienceId !== undefined) {
      body.importHtmlFromAudienceId = importHtmlFromAudienceId;
    }
    const response = await fetch(`${API_BASE_URL}/websites/${websiteId}/audiences/${audienceId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to update audience');
    }
    return response.json();
  },

  // Delete an audience for a website
  delete: async (websiteId, audienceId) => {
    const response = await fetch(`${API_BASE_URL}/websites/${websiteId}/audiences/${audienceId}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      throw new Error('Failed to delete audience');
    }
    return true;
  },
};

